import { SelectField, AllowedValueTypes } from '@/components/forms/inputs';
import { Control, FieldErrors, FieldError } from 'react-hook-form';
import { Grid } from '@mui/material';
import { IDynamicQuestion } from '@/types/types';

export const useDynamicQuestions = (
    control: Control,
    questionData?: IDynamicQuestion[],
    errors?: FieldErrors,
    options?: { required?: boolean },
) => {
    if (questionData) {
        const DynamicQuestions = questionData.map((q) => {
            const answers = q.answers.map((a) => ({
                label: a.phraseId,
                value: a.answerId,
            }));

            return (
                <Grid size={12} key={q.questionId}>
                    <SelectField
                        control={control}
                        name={q.apiFieldName}
                        label={q.phraseId}
                        multiple={q.multiselect}
                        fullWidth={true}
                        value={
                            q.multiselect ? [q.apiFieldName as AllowedValueTypes] : q.apiFieldName
                        }
                        error={errors?.[q.apiFieldName] as FieldError}
                        data={answers}
                        required={options?.required}
                    />
                </Grid>
            );
        });
        return DynamicQuestions;
    } else {
        return null;
    }
};
